import { css } from '@/styled-system/css';

export const alertCloseStyles = css.raw({
  flex: '0',
  marginBlockStart: `calc(-1 * {spacing.Alert.padding.vert})`,
  marginInlineEnd: `calc(-1 * {spacing.Alert.padding.horz})`,
  marginInlineStart: 'Alert.gap.trailing',
  paddingBlockStart: 'Alert.CloseButton.margin.top',
  paddingInlineEnd: 'Alert.CloseButton.margin.right',
});
